module.exports = __webpack_public_path__ + "static/media/event-services-img35.e845b25e.jpg";